export default "__VITE_ASSET__6G55YhY6__"